import { Component, Input, OnInit } from '@angular/core';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import {
    AccessibilityDialogsNewHelpCenterComponent,
} from '@client/app/modules/accessibility/dialogs/new-help-center/new-help-center.component';

@Component({
    selector: 'accessibilityDialogsHelpCenter',
    template: `
        <div class="accessibility-dialogs-help-center">
            <div class="mon-dialog-header">
                <page-header header="{{ 'Accessibility help center' | translate }}"
                             panelClass="row"
                             panelLeftClass="col-48 mt-2">
                </page-header>
            </div>
            <div class="mon-dialog-body">
                <div class="card panel-monsido-card mx-4 mt-4">
                    <div class="card-body pt-3">
                        <div class="row">
                            <div class="col-48 pl-2 help-center-header d-flex align-items-center">
                                <mon-table-policy-type
                                        class="px-2"
                                        [color]="setTypeColor()"
                                        [target]="check.result_type"
                                >
                                </mon-table-policy-type>
                                <h2 [innerHTML]="check.name" class="text-v-middle my-0 mr-auto"></h2>
                                <div>
                                    <button class="btn btn-border-radius emphasised-btn"
                                            *ngIf="'admin_accessibility_help_center' | domainActiveFeature"
                                            (click)="openNewHelpCenter()"
                                            translate>
                                        Open New Help Center
                                    </button>
                                </div>
                            </div>
                            <div class="col-48 px-0">
                                <hr class="mt-2">
                            </div>
                            <div class="col-48 px-4">
                                <div class="accessibility-suggestion" [innerHTML]="html"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    standalone: false,
})
export class AccessibilityDialogsHelpCenterComponent implements OnInit {
    @Input() check: any;
    @Input() data: any;

    html = '';

    constructor (
        private pipeService: PipeService,
        private monEventsService: MonEventService,
    ) {

    }

    ngOnInit () {
        this.getPage();
    }

    getPage () {
        let html = this.data.suggestion;
        html = this.searchAndReplace(html, /\/accessibility\/images\/arrow.gif/g, '/images/accessibility/arrow.gif');
        html = this.searchAndReplace(
            html,
            /<h2>Error Type<\/h2>(\r\n|\r|\n)<span class="msg">.*<\/span>/,
            '<h2>Error Type</h2><span class="msg">' + this.pipeService.get('capitalize')(this.check.result_type) + '</span>',
        );
        this.html = html;
    }

    searchAndReplace (content, search, replace) {
        return content.replace(search, replace);
    }

    setTypeColor () {
        if (this.check.issue_abbr === 'A') {
            return 'wcag-a';
        } else if (this.check.issue_abbr === 'AA') {
            return 'wcag-aa';
        } else if (this.check.issue_abbr === 'AAA') {
            return 'wcag-aaa';
        }
        return 'info';
    }

    openNewHelpCenter () {
        const params = {
            body: AccessibilityDialogsNewHelpCenterComponent,
            data: { check: this.check, data: this.data },
            size: 'lg',
        };

        this.monEventsService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }
}
